


class ClassActivityReportCard {
    constructor($scope, $state, $stateParams, $sce, $rootScope,
        authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS) {
        'ngInject';
        let self = this
        $rootScope.title = "Class Report"
        $scope.loading = true
        self.typeArray = undefined
        self.levelArray = undefined
        self.resPerTheme = undefined
        self.tagArr = undefined
        self.data_set = undefined
        self.header = undefined
        self.perTypeObj = {}
        self.perTagObj = {}
        self.perLevelObj = {}
        self.themeTotal = undefined
        self.no_of_students = undefined
        self.allThemeTotal = {}
        self.noData = true
        $scope.view_only = false
        $scope.filterObj = {}
        self.noAcademics = true
        let myUserId = localStorageService.get('user_id')
        let activeAcd = localStorageService.get('academic_year')
        let school_id = localStorageService.get('school_id')
        let thisSchoolId = school_id
        let filterThru = localStorageService.get('can_filter')
        $scope.allAcademic_year = localStorageService.get('allAcademic_year')
        if (filterThru == "true") {
            filterThru = true
        } else {
            filterThru = undefined
        }
        var insideCourseware = false
        let LEVEL_ARRAY = [{
            level: "1",
            alias: "Easy"
        }, {
            level: "2",
            alias: "Medium"
        }, {
            level: "3",
            alias: "Difficult"
        }]
        //Boolean - To set view for fetch
        $scope.isFilter = true;

        //Object - Holds selection data
        $scope.selectAcademics = {};

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Class Report"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            getSession()
        }


        function getSession() {
            self.noData = true
            $scope.toSearchObj = {
                user_id: myUserId,
                school_id: school_id,
                academic_year: activeAcd,
                exam: {
                    $exists: 1
                }
            }
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.sessions = response.result.data.details;
                        $scope.selectAcademics.session = undefined;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.curriculums = [];
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                        $scope.loading = false;
                    } catch (ex) {
                        console.log(ex)
                    }
                } else {
                    $scope.loading = false
                    toastr.error('Network Error. Please try later')
                }
                _.defer(function () {
                    $scope.$apply();
                });
            })
        }

        $scope.getCuriculum = (session) => {
            self.noData = true
            $scope.selectAcademics.session = session;
            $scope.toSearchObj.session = $scope.selectAcademics.session._id;
            if($scope.toSearchObj && $scope.toSearchObj.academic_year){
                if($scope.toSearchObj.academic_year.year){
                    $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year
                }
            }
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.curriculums = response.result.data.details;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getClass = (curriculum) => {
            self.noData = true
            $scope.selectAcademics.curriculum = curriculum;
            $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
            if($scope.toSearchObj && $scope.toSearchObj.academic_year){
                if($scope.toSearchObj.academic_year.year){
                    $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year
                }
            }
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CLASS_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.classes = response.result.data.details;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getBatch = (xclass) => {
            self.noData = true
            $scope.selectAcademics.class = xclass;
            $scope.toSearchObj.class = $scope.selectAcademics.class._id;
            if($scope.toSearchObj && $scope.toSearchObj.academic_year){
                if($scope.toSearchObj.academic_year.year){
                    $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year
                }
            }
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_BATCH_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.batches = response.result.data.details;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getSubject = (batch) => {
            console.log(batch)
            self.noData = true
            $scope.selectAcademics.batch = batch;
            $scope.toSearchObj.batch = $scope.selectAcademics.batch._id;
            if($scope.toSearchObj && $scope.toSearchObj.academic_year){
                if($scope.toSearchObj.academic_year.year){
                    $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year
                }
            }
            
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SUBJECT_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.subjects = response.result.data.details;
                        console.log($scope.subjects)
                        $scope.selectAcademics.subject = undefined;
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
        $scope.fetchReport = function (subject) {
            self.noData = true
            $scope.selectAcademics.subject = subject;
            $scope.selectedAcademics = angular.copy($scope.selectAcademics);
            $scope.toSearchObj.subject = $scope.selectAcademics.subject._id;
            
        }
        $scope.getReport = (year) => {
            $scope.toSearchObj.academic_year = year
            
        }
        $scope.uCanTrust = function (obj) {
            // string = "<span style='color: #89a000'>123</span>"
            if (obj && obj.color) {
                let color = obj.color['background-color']
                let string = '<span class="td-color" style="background-color:' + color + ';">' + obj.score + '</span>';
                return $sce.trustAsHtml(string);
            }

        }
        $scope.barcodeToHtml = function () {
            let lines = $scope.REFERENCE.bcode.lines
            let barcodeNumber = $scope.REFERENCE.bcode.barcodeNumber
            return $sce.trustAsHtml(lines+barcodeNumber);
        }
        
        let authoring = localStorageService.get('authoringData')
        // loadData(authoring)
        function loadData(academics) {
            $scope.loading = true
            self.noAcademics = false
            self.academicsForExp = academics
            let send = {
                "conditions": {
                    "class_id": academics.class,
                    "curriculum_id": academics.curriculum,
                    "batch_id": academics.batch,
                    "subject_id": academics.subject,
                    "session_id": academics.session,
                    "school_id": school_id
                },
                "myUserId": myUserId,
                "acdYear": academics.academic_year ? academics.academic_year.year : activeAcd,
                // "student_id": "q72pkhd4GGKeoy7sA",
                "pdfFlag": false,
                "FILE_UPLOAD_URL": CONSTANTS.FILE_UPLOAD_URL,
                "SITE_URL": CONSTANTS.SITE_URL
            }
            
            // return false
            authService.callAPI("/v0/educore_reports/clasReportRedef", "POST",
                { args: send }, function (resp) {
                    try {
                        
                        console.log('sendsendsendsend')
                        if (!resp.error) {
                            let response = resp.result.data.details
                            console.log(response)
                            if (response.typesUsed && response.typesUsed.length) {
                                self.noData = false
                            } else {
                                toastr.error("No results available")
                                self.noData = true
                            }

                            let data = response
                            let typeData = data.type_obj
                            self.themeArray = data.themeArray
                            self.header = data.header
                            self.typeArray = data.typesUsed
                            self.data_set = data.type_obj
                            self.level_set = data.level_obj
                            self.tag_set = data.tag_obj
                            self.perTypeObj = data.type_total
                            self.perLevelObj = data.level_total
                            self.perTagObj = data.tag_total
                            self.levelArray = LEVEL_ARRAY
                            self.tagArr = data.tagsUsed
                            self.allScorePerTheme = data.allScorePerTheme
                            self.allThemeTotal = data.allThemeTotal
                            self.no_of_students = data.batchStudentIds.length
                            self.highest = data.highest
                            self.levelAveragesPerTheme = data.levelAveragesPerTheme
                            self.tagAveragesPerTheme = data.tagAveragesPerTheme
                            self.totalLevelObj = data.totalLevelObj
                            self.totalTagObj = data.totalTagObj
                            self.generated_date = data.generated_date
                            self.generated_by = data.generated_by
                            let colSpanCountTag = 4
                            colSpanCountTag = colSpanCountTag + self.themeArray.length
                            self.tagCollSpan = colSpanCountTag
                            $scope.urls = data.pdf_url
                            $scope.REFERENCE = data.REFERENCE
                        } else {
                            $scope.loading = false;
                            toastr.error("Network error");
                        }
                    } catch (e) {
                        
                        console.log(e)
                    }
                    
                    $scope.loading = false
                    $scope.$apply()
                })
        }


        $scope.findReport = () => {
            if(!$scope.toSearchObj.academic_year){
                toastr.error("please select year")
                return false
            }
            loadData($scope.toSearchObj)
        }
        self.export = () => {
            // $scope.loading = true
            $scope.isPdfData = true
            console.log($scope.urls)
            $scope.url = $sce.trustAsResourceUrl($scope.urls)
        }
        self.backToHtml = () => {
            $scope.isPdfData = false
        }
        $scope.ref_code = undefined
        $scope.submitRefCode = () => {
            $scope.loading = true
            authService.callAPI("/v0/educore-reports/getreportbyreference", "POST",
                { args: {
                    ref_code : $scope.ref_code,
                    type : 'class_report',
                    FILE_UPLOAD_URL : CONSTANTS.FILE_UPLOAD_URL,
                    user_id : myUserId
                } }, function (resp) {
                    try{
                        if (!resp.error) {
                            let response = resp.result.data.details
                            console.log(response)
                            if (response.typesUsed && response.typesUsed.length) {
                                self.noData = false
                            } else {
                                toastr.error("No results available")
                                self.noData = true
                            }
                            let data = response
                            let typeData = data.type_obj
                            self.themeArray = data.themeArray
                            self.header = data.header
                            self.typeArray = data.typesUsed
                            self.data_set = data.type_obj
                            self.level_set = data.level_obj
                            self.tag_set = data.tag_obj
                            self.perTypeObj = data.type_total
                            self.perLevelObj = data.level_total
                            self.perTagObj = data.tag_total
                            self.levelArray = LEVEL_ARRAY
                            self.tagArr = data.tagsUsed
                            self.allScorePerTheme = data.allScorePerTheme
                            self.allThemeTotal = data.allThemeTotal
                            self.no_of_students = data.batchStudentIds.length
                            self.highest = data.highest
                            self.levelAveragesPerTheme = data.levelAveragesPerTheme
                            self.tagAveragesPerTheme = data.tagAveragesPerTheme
                            self.totalLevelObj = data.totalLevelObj
                            self.totalTagObj = data.totalTagObj
                            self.generated_date = data.generated_date
                            self.generated_by = data.generated_by
                            let colSpanCountTag = 4
                            colSpanCountTag = colSpanCountTag + self.themeArray.length
                            self.tagCollSpan = colSpanCountTag
                            $scope.urls = data.pdf_url
                        }
                        $scope.loading = false
                        $scope.$apply()
                    }catch(e){
                        console.log(e)
                    }
                })
        }
    }
}
export default ClassActivityReportCard;


// WEBPACK FOOTER //
// ./src/app/educore_reports/class/controllers/controller.js